export default function CsStudyPlan() {
  return (
    <h2>Cs Study Plan</h2>
  );
}
